<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-1 class="text-left fw-500">1. Definitions and Interpretations</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-1" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>"Account Holder" refers to the individual or entity that has registered for a Virtual Account on the RCPAY Virtual Account Platform.</li>
                        <li>"Virtual Account (VA)" refers to the electronic account provided by RCPAY Virtual Account.</li>
                        <li>"Platform" refers to RCPAY Virtual Account, the provider of the VA service.</li>
                        <li>"User" refers to any person accessing or using the VA service.</li>
                        <li>"Business Day" means a day (other than a Saturday, Sunday, or public holiday) on which banks in Hong Kong are open for business.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-1',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>